import { Box } from '@mui/material';
import ThemeSwitcher from './ThemeSwitcher';
import { LoadingButton } from '@mui/lab';
import { MdOutlineArchive } from 'react-icons/md';
import { useContext } from 'react';
import { AuthContext } from 'src/contexts/AuthContext';
import useBackupDb from 'src/hooks/query/db/useBackupDb';
import useDownloadBackup from 'src/hooks/query/db/useDownloadBackup';

function HeaderButtons() {
  const { user: me } = useContext(AuthContext);
  const { isLoading: downloadBackupLoading, downloadBackupMutation } =
    useDownloadBackup();
  const { isLoading, backupDbMutation } = useBackupDb(() => {
    console.log('Backup completed, triggering download...');
    downloadBackupMutation();
  });

  return (
    <Box sx={{ mr: 1 }}>
      {me?.role_id == 1 && (
        <LoadingButton
          startIcon={<MdOutlineArchive />}
          color="secondary"
          onClick={() => backupDbMutation()}
          loading={isLoading || downloadBackupLoading}
        >
          Backup Database
        </LoadingButton>
      )}
      <ThemeSwitcher />
    </Box>
  );
}

export default HeaderButtons;
